<template>
  <div></div>
</template>

<script setup lang="ts">
const { isInitialized, initializeWidget } = useSuperchat()

const config = useRuntimeConfig()

onMounted(() => {
  watch(
    isInitialized,
    (initialized) => {
      if (initialized && config.public.SUPERCHAT_APP_KEY) {
        initializeWidget(config.public.SUPERCHAT_APP_KEY)
      }
    },
    { immediate: true }
  )
})
</script>
